import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useSite, imgUrl } from "@/context/SiteContext";

export default function ArticlesSection({ articles }) {
  const { t } = useSite();
  return (
    <section id="artikel" className="py-16 sm:py-24" data-testid="articles-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="eyebrow mb-4">{t("art.eyebrow")}</p>
        <h2 className="mb-12 max-w-2xl text-3xl font-bold tracking-tight text-[#0F2B48] lg:text-4xl">{t("art.title")}</h2>
        <div className="grid gap-8 md:grid-cols-3">
          {articles.map((a) => (
            <Link key={a.id} to={`/artikel/${a.slug}`} data-testid={`article-card-${a.slug}`} className="group block">
              <div className="h-48 overflow-hidden"><img src={imgUrl(a.cover)} alt={a.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" /></div>
              <div className="mt-5 flex items-center gap-3 font-mono text-[11px] uppercase tracking-widest text-slate-500">
                <span className="text-[#D97706]">{a.category}</span><span>·</span><span>{a.read_time} {t("art.min")}</span>
              </div>
              <h3 className="mt-2 flex items-start justify-between gap-3 text-lg font-semibold leading-snug text-[#0F2B48]">
                {a.title} <ArrowUpRight size={18} className="shrink-0 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{a.excerpt}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
